import { z } from "zod";
import { ISODateTime as IsoDateTimeString } from "./primitives";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

export const ReferralPromotionDateFormat = IsoDateTimeString;
export type ReferralPromotionDateFormat = z.infer<typeof ReferralPromotionDateFormat>;

const ReferralNominationId = z.uuid();

export const Nomination = z.object({
    id: ReferralNominationId,
    firstName: z.string().max(256),
    lastName: z.string().max(256),
    phoneNumber: z.string().max(256),
    createdAt: ReferralPromotionDateFormat,
});

export type Nomination = z.infer<typeof Nomination>;
